import { render, staticRenderFns } from "./FarmaciaSelector.vue?vue&type=template&id=386ae0be"
import script from "./FarmaciaSelector.vue?vue&type=script&lang=js"
export * from "./FarmaciaSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports